var map = {
	"./Features-Block-Reviews-DA-DK-D.png": 36744,
	"./Features-Block-Reviews-DE-DE-D.png": 87550,
	"./Features-Block-Reviews-EN-GB-D.png": 9192,
	"./Features-Block-Reviews-EN-US-D.png": 28643,
	"./Features-Block-Reviews-ES-ES-D.png": 89748,
	"./Features-Block-Reviews-ES-MX-D.png": 30215,
	"./Features-Block-Reviews-FR-FR-D.png": 84572,
	"./Features-Block-Reviews-IT-IT-D.png": 28582,
	"./Features-Block-Reviews-NB-NO-D.png": 12853,
	"./Features-Block-Reviews-NL-NL-D.png": 37048,
	"./Features-Block-Reviews-PL-PL-D.png": 35504,
	"./Features-Block-Reviews-PT-BR-D.png": 14588,
	"./Features-Block-Reviews-PT-PT-D.png": 14016,
	"./Features-Block-Reviews-SV-SE-D.png": 17941
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89939;